import React from 'react'
import {
  textWithHTML,
  percentage,
  numberMoney,
  textToNumber,
} from 'Data/format.js'
import { useDataValue } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let card_fee_percent = useDataValue({
    context: 'reusable_method',
    path: 'provider_location_account.card_fee_percent',
    viewPath: props.viewPath,
  })

  let amount = textToNumber(props.amount)

  return (
    <View
      text={textWithHTML(
        `A <b>fee of ${
          amount
            ? `${numberMoney((amount * card_fee_percent) / 100)} (${percentage(card_fee_percent)})`
            : percentage(card_fee_percent)
        }</b> will be added.`
      )}
      {...props}
    />
  )
}
